import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { Controller, useFormContext } from 'react-hook-form';

import { fc } from 'i18n';
import { ITepEntryPass } from 'types/tep';
import Input from 'core/react/general/form/Input';
import { selectedLeasesIdSelector } from 'core/redux/selectors/tep';

import styles from './styles.module.css';

interface IPlateNumberProps {
  entryPass: ITepEntryPass;
}

export const PlateNumber: FC<IPlateNumberProps> = ({ entryPass }) => {
  const id = useSelector(selectedLeasesIdSelector);

  const { formState, control } = useFormContext<{ device: ITepEntryPass }>();

  const { errors } = formState;

  const isSelected = entryPass?.id === id;
  const error = errors.device?.lease?.plateNumber?.message;

  return isSelected ? (
    <Controller
      control={control}
      name="device.lease.plateNumber"
      rules={{ required: fc('please enter vehicle plate no.') }}
      render={({ value, onChange }) => (
        <div className={styles.input}>
          <Input placeholder="enter vehicle plate no." value={value} onChange={onChange} />
          {/*TODO: error messages should be moved to corresponding form components when they are being refactored*/}
          {!!error && <div className={styles.error}>{error}</div>}
        </div>
      )}
    />
  ) : (
    <div>{entryPass.lease?.plateNumber || '-'}</div>
  );
};
